import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyModal = (props) => {
  const { t } = useTranslation('common');
  const { close, hideAcceptButton } = props;

  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(false);
    close();
  };

  useEffect(() => {
    setModal(props.show || false);
  }, [props.show]);

  return (
    <div>
      <Modal
        centered
        className="account-roles-modal"
        style={{ maxWidth: 1000 }}
        size={'lg'}
        isOpen={modal}
        toggle={toggle}
        backdrop={'static'}
        keyboard={true}
      >
        <ModalHeader toggle={toggle}>
          <span style={{ fontWeight: 700, fontSize: 30, color: 'var(--productPrimary)' }}>
            {t('Privacy')} <span style={{ color: 'var(--productGray)' }}>{t('Policy')}</span>
          </span>
          <span
            className="float-right"
            style={{
              fontSize: 14,
              color: 'var(--productGray)',
              marginTop: 4,
              marginRight: 50
            }}
          >
            <strong>{t('Last Update : 27 / 03 / 2019')}</strong>
          </span>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 14 }}>
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
            <strong>{t('Introduction')}</strong>
            <br />
            {t(
              'In return for HBSUK allowing you access to this website, HBSUK imposes and requires you to accept the Terms. If you are not prepared to agree to these Terms, then HBSUK requires you to immediately leave this website.'
            )}
            <br />
            <br />
          </p>
        </ModalBody>
        <ModalFooter className={classnames({ 'd-none': hideAcceptButton })}>
          <Button
            color="primary"
            className="btn-block"
            style={{ backgroundColor: 'var(--productPrimary)' }}
            onClick={toggle}
          >
            {t('Accept')}
          </Button>{' '}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PrivacyPolicyModal;
